<script lang="ts">import { GLOBAL_NAV_MOBILE_CART_CONTENT_ID } from '../../../../../../js-v2/constants';
import { mobileNavStateStore } from '../../../../../../js-v2/stores/mobile-nav-stores';
import { onTouchOrClick } from '../../../../../../js-v2/onTouchOrClick';
import { getTracking } from '../../../../../../js-v2/tracking';
import { getNavDeviceType } from '../../../../../../js-v2/trackingUtils';
import { getUrlPath } from '../../../../../../js-v2/urlUtils';
const { id = '', title = 'Checkout' } = $props();
const trackFn = getTracking();
let buttonEl = $state();
function open() {
    trackFn({
        eventName: 'Open Cart',
        properties: {
            currentPage: getUrlPath(),
            navDeviceType: getNavDeviceType(buttonEl),
        },
    });
    mobileNavStateStore.push({
        type: 'cart',
    });
}
</script>

<button
  bind:this={buttonEl}
  class="Button"
  data-entry-id={id}
  aria-controls={GLOBAL_NAV_MOBILE_CART_CONTENT_ID}
  use:onTouchOrClick={open}
>
  <span class="icon">
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.125 10.75C4.64375 10.75 4.25 11.1438 4.25 11.625C4.25 12.1062 4.64375 12.5 5.125 12.5H16.5V14.25H5.125C3.68125 14.25 2.5 13.0687 2.5 11.625C2.5 10.6012 3.095 9.7175 3.96125 9.28875L2.5 2H0.75V0.25H6V2H16.5L14.75 10.75H5.125ZM13.315 9L14.365 3.75H4.635L5.685 9H13.315ZM5.5625 17.75C6.28737 17.75 6.875 17.1624 6.875 16.4375C6.875 15.7126 6.28737 15.125 5.5625 15.125C4.83763 15.125 4.25 15.7126 4.25 16.4375C4.25 17.1624 4.83763 17.75 5.5625 17.75ZM13.4375 17.75C14.1624 17.75 14.75 17.1624 14.75 16.4375C14.75 15.7126 14.1624 15.125 13.4375 15.125C12.7126 15.125 12.125 15.7126 12.125 16.4375C12.125 17.1624 12.7126 17.75 13.4375 17.75Z"
        fill="#232425"
      />
    </svg>
  </span>
  <span class="title">{title}</span>
</button>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.Button {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  position: relative;
  min-height: 0;
  max-height: none;
  margin: 0;
  padding: 2px;
  border-radius: 6px;
  border: 0;
  outline: 0;
  color: var(--color-text, var(--color-neutral-000, #000000));
  background-color: transparent;
  letter-spacing: normal;
  text-align: left;
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.Button:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.Button:focus {
  background: transparent;
  outline: none;
}
.Button:hover {
  background: transparent;
}
.Button:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.Button .icon {
  display: inline-flex;
  align-items: center;
  height: 21px;
  width: 21px;
}
.Button .icon :global(svg *) {
  fill: var(--color-text, var(--color-neutral-000, #000000));
}
.Button .title {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  display: block;
  display: inline;
  padding: 3px 0px;
}</style>
